import { api, request } from "./_request";

export const logout = () => {
  return (dispatch) => {
    //Borrar de la base de datos

    api()
      .post("/logout")
      .then(function (response) {
        if (response.status === 200) {
          //Borrar de la memoria local
          localStorage.removeItem("ses-tok-pa-evt");
          dispatch({
            type: "DESCONECTADO",
            payload: "Desconectado",
          });
        }
      });
  };
};

export const login = (params) => {
  return (dispatch) => {
    request
      .post("/oauth/token", {
        username: params.email,
        password: params.password,
        client_id: 2,
        client_secret: "2ExjgUc17yPUoGZZb18PAM3ka9OsgXMmW9noo6q9",
        grant_type: "password",
      })
      .then(function (response) {
        if (response.status === 200) {
          localStorage.setItem("ses-tok-pa-evt", JSON.stringify(response.data));
          dispatch({
            type: "CONECTADO",
            payload: response.data,
          });
        }
      })
      .catch(function (error) {
        dispatch({
          type: "ERROR",
          payload: "Datos incorrectos.",
        });
      });
  };
};

export const checktoken = () => {
  return (dispatch) => {
    let token = localStorage.getItem("ses-tok-pa-evt");

    token = JSON.parse(token);

    if (token !== null) {
      let AuthorizationToken = token.token_type + " " + token.access_token;

      request
        .get("api/user", {
          responseType: "json",
          headers: { Authorization: AuthorizationToken },
        })
        .then(function (response) {
          if (response.status === 200) {
            dispatch({
              type: "CONECTADO",
              payload: token,
            });
          }
        })
        .catch(function (error) {
          // delete token
          localStorage.removeItem("ses-tok-pa-evt");
        });
    }
  };
};

export const whoiam = () => {
  return (dispatch) => {
    api()
      .get("/user")
      .then(function (response) {
        dispatch({
          type: "AUTH_WHOIAM_SUCCESS",
          payload: response.data,
        });
      });
  };
};
